import ActionType from 'actions/ActionType'

export default (state = { phone_number: 'none' }, action) => {
  switch (action.type) {
    case ActionType.Data.LIST_SUCCESS:
      if (action.entityType === 'phonenumbers' && Array.isArray(action.payload)) {
        const defaultPhone = action.payload.find((element) => element.default)
        if (defaultPhone) {
          return defaultPhone
        } else {
          if (
            action.payload &&
            action.payload[0]
          ) {
            return action.payload[0]
          }
        }
      }
      return state
    case ActionType.Inbox.SELECT_FROM_NUMBER:
      return action.payload
    default:
      return state
  }
}
